import {Dispatch, SetStateAction} from 'react';

import {Box} from '@mui/material';
import {t} from 'i18next';

import {Button} from 'components/button/Button';

import {InfoIconWrapper, StyledTypography, UpchargeContainer} from './styles';

type UpchargeBannerProps = {
  setShowUpchargeModal: Dispatch<SetStateAction<boolean>>;
  upchargePercentage: number;
  isWeightedFresh: boolean;
};

const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" enable-background="new 0 0 16 16">
    <circle fill="#FFF" cx="8" cy="8" r="8" />
    <path
      fill="#F26233"
      d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,13c-0.5,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1
	S8.5,13,8,13z M9,9H7V3h2V9z"
    />
  </svg>
);

export const UpchargeBanner: React.FC<UpchargeBannerProps> = ({
  setShowUpchargeModal,
  upchargePercentage,
  isWeightedFresh
}) => {
  return (
    <UpchargeContainer>
      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <InfoIconWrapper>
          <InfoIcon />
        </InfoIconWrapper>
        <StyledTypography>
          {isWeightedFresh
            ? t('weightedFresh.basketMessage', {percentage: upchargePercentage})
            : t('upcharge.basketMessage', {percentage: upchargePercentage})}
        </StyledTypography>
      </Box>
      <Button sx={{lineHeight: '21px'}} onClick={() => setShowUpchargeModal(true)}>
        {t('upcharge.seeMore')}
      </Button>
    </UpchargeContainer>
  );
};

export default UpchargeBanner;
